import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [countdown, setCountdown] = useState({ hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const target = new Date('2026-08-15T20:00:00').getTime();
    const timer = setInterval(() => {
      const now = Date.now();
      const diff = Math.max(0, target - now);
      setCountdown({
        hours: Math.floor(diff / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[780px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20floodlights%2C%20abstract%20geometric%20energy%20waves%20in%20warm%20red%20and%20gold%20tones%2C%20large%20crowd%20silhouettes%2C%20professional%20sports%20broadcast%20style%2C%20dark%20background%20with%20vibrant%20red%20and%20amber%20accent%20lights%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20clean%20composition&width=1920&height=1080&seq=hero-bg-mile&orientation=landscape"
          alt="米乐体育"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 flex flex-col items-center text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-background-50/90">英超新赛季倒计时</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight max-w-4xl">
          全球顶级赛事
          <br />
          <span className="text-primary-400">一网打尽</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/70 max-w-2xl mt-5 mb-10 leading-relaxed">
          米乐体育汇聚足球、篮球、网球、电竞等全球热门赛事，提供高清直播、专业数据分析与趣味竞猜服务，
          为每一位体育爱好者打造专属的观赛体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-12">
          <Link
            to="/register"
            className="px-8 py-3.5 rounded-full text-base font-bold bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-primary-600 hover:scale-105"
          >
            立即注册 领专属福利
          </Link>
          <Link
            to="/category/live"
            className="px-8 py-3.5 rounded-full text-base font-medium border border-background-50/40 text-background-50 whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-background-50/10"
          >
            观看直播
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>

        <div className="flex items-center gap-4 md:gap-6 bg-background-50/10 backdrop-blur-sm rounded-2xl px-6 md:px-10 py-5 border border-background-50/10">
          {[
            { value: countdown.hours.toString().padStart(2, '0'), label: '时' },
            { value: countdown.minutes.toString().padStart(2, '0'), label: '分' },
            { value: countdown.seconds.toString().padStart(2, '0'), label: '秒' },
          ].map((item, idx) => (
            <div key={item.label} className="flex items-center gap-4 md:gap-6">
              {idx > 0 && <span className="text-background-50/40 text-xl font-bold">:</span>}
              <div className="text-center">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl bg-background-50/15 flex items-center justify-center">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-background-50">{item.value}</span>
                </div>
                <span className="text-xs text-background-50/60 mt-2 block">{item.label}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-12">
          {[
            { icon: 'ri-user-smile-line', value: '500万+', label: '注册用户' },
            { icon: 'ri-live-line', value: '2000+', label: '日均赛事' },
            { icon: 'ri-shield-check-line', value: '99.9%', label: '安全可靠' },
            { icon: 'ri-customer-service-2-line', value: '7×24h', label: '客服支持' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center">
                <i className={`${stat.icon} text-background-50/80 text-sm`}></i>
              </div>
              <div className="text-left">
                <div className="font-heading text-lg md:text-xl font-bold text-background-50">{stat.value}</div>
                <div className="text-xs text-background-50/50">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}